import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const MerchantFilters = ({ filters, searchTerm, onFilterChange, onSearch, onReset }) => {
  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending' },
    { value: 'suspended', label: 'Suspended' },
    { value: 'inactive', label: 'Inactive' }
  ];

  const businessTypeOptions = [
    { value: '', label: 'All Types' },
    { value: 'ecommerce', label: 'E-commerce' },
    { value: 'retail', label: 'Retail' },
    { value: 'service', label: 'Service' },
    { value: 'food', label: 'Food & Beverage' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Search */}
        <div className="md:col-span-2">
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search by name, email, or ID..."
              value={searchTerm}
              onChange={(e) => onSearch(e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>

        {/* Status Filter */}
        <div>
          <Select
            value={filters?.status || ''}
            onChange={(e) => onFilterChange({ ...filters, status: e?.target?.value })}
            options={statusOptions}
          />
        </div>

        {/* Business Type Filter */}
        <div>
          <Select
            value={filters?.businessType || ''}
            onChange={(e) => onFilterChange({ ...filters, businessType: e?.target?.value })}
            options={businessTypeOptions}
          />
        </div>
      </div>

      {/* Reset Button */}
      {(searchTerm || filters?.status || filters?.businessType) && (
        <div className="mt-4 flex justify-end">
          <Button
            variant="outline"
            size="sm"
            onClick={onReset}
            className="flex items-center gap-2"
          >
            <Icon name="X" size={16} />
            Reset Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default MerchantFilters;